var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"series-category-btn",attrs:{"to":_vm.link}},[_c('img',{attrs:{"src":_vm.bg,"alt":_vm.category.label}}),_c('div',{staticClass:"is-overlay"},[_c('h3',[_vm._v(_vm._s(_vm.category.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }